import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { OtherExpensesModel } from 'api-hooks/other-expense';
import { OtherIncomeModel } from 'api-hooks/other-income';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import { ApiError, ExtendedApiResult } from 'common/repositories/common.model';

import { getTipsInput } from './model';

export function useGetOtherExpenses(
  input?: getTipsInput,
  options?: UseQueryOptions<ExtendedApiResult<OtherExpensesModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<OtherExpensesModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['get-other-expenses-sales', input],
      () =>
        QueryFetchFunction({
          url: `sales/${input?.id}/get-other-expenses`,
          params: input?.params,
        }),
      options,
    ),
    OtherExpensesModel,
  );
}

export function useGetOtherIncome(
  input?: getTipsInput,
  options?: UseQueryOptions<ExtendedApiResult<OtherIncomeModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<OtherIncomeModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['get-other-incomes-sales', input],
      () =>
        QueryFetchFunction({
          url: `sales/${input?.id}/get-other-incomes`,
          params: input?.params,
        }),
      options,
    ),
    OtherIncomeModel,
  );
}

export function getTipsKey(input?: getTipsInput) {
  return ['getTips', input];
}
